import styles from './Text.module.scss';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Text = ({ className, children, ...props }) => {
  return (
    <p className={classNames(styles.text, className)} {...props}>
      {children}
    </p>
  );
};

Text.propTypes = {
  className: PropTypes.string,
};

Text.defaultProps = {
  className: null,
};

export default Text;
